import Router from "./Components/Routers/Router";

function App() {
  return (
    <div>
      <Router></Router>
    </div>
  );
}

export default App;
